var _defs, _g, _defs2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLorePrevChapterBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 427,
    height: 190,
    viewBox: "0 0 427 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "prev-chapter-bg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n            #prev-chapter-bg:hover path {\n                fill: rgba(255, 255, 255, .1);\n            }\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_459_2115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 26C0.5 21.8579 3.85786 18.5 8 18.5H115.122C117.417 18.5 119.614 17.5722 121.214 15.9275L134.503 2.26984C135.915 0.818648 137.853 0 139.878 0H200.5C202.592 0 204.589 0.873416 206.008 2.40943L229.524 27.8532C232.349 30.909 236.97 31.4709 240.444 29.181L254.772 19.7378C255.997 18.9304 257.432 18.5 258.899 18.5H394.5H419C423.142 18.5 426.5 21.8579 426.5 26V161C426.5 165.142 423.142 168.5 419 168.5H28.5557C26.9972 168.5 25.4774 168.014 24.2075 167.111L3.65184 152.485C1.67438 151.078 0.5 148.801 0.5 146.374V26Z",
    stroke: "#D9D9D9"
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_459_2115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 427,
    height: 190,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLorePrevChapterBg);
export default __webpack_public_path__ + "static/media/lore-prev-chapter-bg.39867db1d71e30d7168de931acd66403.svg";
export { ForwardRef as ReactComponent };